export default function FooterPublic() {
  const year = new Date().getFullYear();

  return (
    <footer data-testid="footer-public" className="w-full text-center text-xs text-neutral-600 py-4 flex flex-col gap-2">
      <div className="flex items-center justify-center gap-3">
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSfVkY4UDixIbaDopdiIZzoCH91qZFjX0jdh9uH-vZ2EELraxg/viewform"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-neutral-600 transition-colors underline"
        >
          Canal de denuncias
        </a>
        <span className="text-neutral-300">|</span>
        <a
          href="https://forms.gle/MeWEFigNcuPajfNf7"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-neutral-600 transition-colors underline"
        >
          Canal LGPD
        </a>
      </div>
      <p>
        LIQI | {year} — Todos os direitos reservados —{" "}
        <a
          href="/documents/termo-de-uso.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-neutral-600 transition-colors underline"
        >
          Termos de uso
        </a>
      </p>
    </footer>
  );
}
